export default __webpack_public_path__ + "static/media/GothamMedium.0a910c0b.ttf";